<nav>
  <img
    (click)="goTo('cliente/dashboard')"
    src="/assets/img/logos/logo-complet-red.png"
    alt="logo"
  />
  <div>
    <div class="profile">
      <div (click)="menu = !menu">
        <a class="body-2">
          <img
            class="user-pic"
            alt="user-pic"
            [src]="
              user?.image ? user?.image : '/assets/img/Default-User-Pic.svg'
            "
          />
          {{ user?.username }}
        </a>
        <span class="icon-Arrow-Dropdown"></span>
      </div>
      <div
        class="user-options"
        *ngIf="menu"
        ggiJourneyCloseComponent
        (closeComponent)="menu = false"
      >
        <div class="user-option body-2" (click)="goTo('cliente/perfil')">
          Mi Perfil
        </div>
        <div class="user-option body-2" (click)="logout()">Cerrar sesión</div>
      </div>
    </div>
  </div>
</nav>
